<div class="container">
  <h3 class="leaderboard-title text-white">{{ 'fantasy.leaderboard.title' | translate }}</h3>

  <p class="font-size-14 mb-0 text-white">{{ 'fantasy.leaderboard.description' | translate }}</p>

  <div class="leaderboard-container">
    <fgb-leaderboard [toShow]="20" [LeaderboardType]="LeaderboardType" [isLeaderboard]="true"></fgb-leaderboard>
  </div>
</div>
